import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const StContainer = styled.div`
  width: 100%;
  position: relative;
  z-index: 10;
`

const StFieldContainer = styled.div`
  width: 100%;
`

const StInputContainer = styled.label<{ error?: boolean }>`
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 1;

  transition: all 0.3s ease;

  ${({ theme, error }) => {
    return `
      background-color: ${error ? theme.Components.Input.ErrorFill : theme.Components.Input.Fill};
      border: 1px solid ${error ? theme.Components.Input.ErrorBorder : theme.Components.Input.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;
      color: ${error ? theme.Components.Input.ErrorText : theme.Components.Input.Text};


      > input {
        width: 100%;
        padding: ${theme.UI.SpacingPx.Space4};

        &::placeholder {
          color: ${theme.Components.Input.Placeholder};
        }

        &:disabled {
          color: ${theme.Components.Input.DisabledText};
          border-color: ${theme.Components.Input.DisabledBorder};
          background-color: ${theme.Components.Input.DisabledFill};
        }
      }

      &:focus-within {
        outline: none;

        ${
          error
            ? ``
            : `
        border-color: ${theme.Components.Input.ActiveBorder};
        background-color: ${theme.Components.Input.ActiveFill};

        `
        }
      }
    `
  }}
`

const StInputIcon = styled(FontAwesomeIcon)`
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
`

const StSuggestionContainer = styled.div`
  position: absolute;
  top: 5.75rem;
  left: 0;
  right: 0;
  z-index: 100;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => {
    return `
      gap: ${theme.UI.SpacingPx.Space1};
      background-color: ${theme.Components.Input.Fill};
      border: 1px solid ${theme.Components.Input.Border};
      border-radius: 0 0 ${theme.UI.BorderRadius.Small}px ${theme.UI.BorderRadius.Small}px;
      margin-top: -${theme.UI.SpacingPx.Space1};
      color: ${theme.Components.Input.Text};
    `
  }}
`

const StSuggestion = styled.button`
  width: 100%;
  cursor: pointer;
  background-color: ${({ theme }) => theme.Components.Conversational.ActiveFill};
  color: ${({ theme }) => theme.Components.Conversational.ActiveText};

  padding: ${({ theme }) => `${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space4}`};
  text-align: left;
  white-space: normal;
`

const StInputErrorContainer = styled.div`
  z-index: 0;
`

export {
  StContainer,
  StFieldContainer,
  StInputContainer,
  StInputErrorContainer,
  StInputIcon,
  StSuggestion,
  StSuggestionContainer,
}
